import './App.css';
import React from 'react';
import { RouterProvider } from 'react-router-dom';
import router from './router';
import { AdminProvider } from './AdminContext';

const App: React.FC = () => {
  return (
    <AdminProvider>
      <RouterProvider router={router} />
    </AdminProvider>
  );
};

export default App;

